import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext, useState } from 'react';
import { createPortal } from 'react-dom';
import cn from 'classnames';
import { CloseButton } from '../CloseButton';
import { useDevice } from '../Device';
import { Divider } from '../Divider';
import { Typography } from '../Typography';
import styles from './FullPageModal.module.scss';
const HeaderStartContext = /*#__PURE__*/ React.createContext(null);
const HeaderEndContext = /*#__PURE__*/ React.createContext(null);
export function FullPageModal(props) {
    const { children, className, contentClassName, contentSkin = 'default', testId, onClose, scrollContainerRef } = props, rest = _object_without_properties(props, [
        "children",
        "className",
        "contentClassName",
        "contentSkin",
        "testId",
        "onClose",
        "scrollContainerRef"
    ]);
    const { isMobileDevice } = useDevice();
    const [headerStartEl, setHeaderStartEl] = useState(null);
    const [headerEndEl, setHeaderEndEl] = useState(null);
    const closeBtn = /*#__PURE__*/ _jsx(CloseButton, {
        skin: "transparent",
        testId: testId && testId + '-close-btn',
        onClick: onClose
    });
    const wrapWithProviders = (children)=>/*#__PURE__*/ _jsx(HeaderStartContext.Provider, {
            value: headerStartEl,
            children: /*#__PURE__*/ _jsx(HeaderEndContext.Provider, {
                value: headerEndEl,
                children: children
            })
        });
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({}, rest), {
        className: cn(styles.root, className, {
            [styles.mobile]: isMobileDevice
        }),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.header,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.flexContainer,
                        children: [
                            closeBtn,
                            /*#__PURE__*/ _jsx(Divider, {
                                orientation: "vertical",
                                margin: 8,
                                size: 32
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h5",
                                weight: "normal",
                                className: styles.flexContainer,
                                ref: setHeaderStartEl,
                                testId: testId && testId + '-header-start'
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.flexContainer,
                        children: /*#__PURE__*/ _jsx("div", {
                            ref: setHeaderEndEl,
                            className: styles.flexContainer
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: cn(styles.content, styles["".concat(contentSkin, "Skin")], contentClassName),
                ref: scrollContainerRef,
                "data-testid": testId && "".concat(testId, "-content"),
                children: wrapWithProviders(children)
            })
        ]
    }));
}
const useSlot = (context, children)=>{
    const element = useContext(context);
    return element ? /*#__PURE__*/ createPortal(children, element) : null;
};
/** Renders its children inside the headerStart slot. */ export const FullPageModalHeaderStart = (p)=>useSlot(HeaderStartContext, p.children);
/** Renders its children inside the headerEnd slot. */ export const FullPageModalHeaderEnd = (p)=>useSlot(HeaderEndContext, p.children);
export function FullPageModalMainActions(props) {
    return useSlot(HeaderEndContext, /*#__PURE__*/ _jsx("div", {
        className: styles.flexContainer,
        children: props.children
    }));
}
FullPageModal.HeaderStart = FullPageModalHeaderStart;
FullPageModal.HeaderEnd = FullPageModalHeaderEnd;
FullPageModal.MainActions = FullPageModalMainActions;
